/**
 * @Author: Nemo
 * @Description: 业务组件库入口文件
 * @Date: 2023-06-18
 */

// 导入支付表单组件
import CardInformationForm from './card-information-form';
import OnCountdownTimer from './countdown-timer/index.vue';
import CountrySelect from './country-select';
import DynamicForm, { FormField } from './dynamic-form';
import OnErrorMsgPanel from './errorMsg-panel/index.vue';
import OnPaymentOptionSelector from './payment-option-selector/index.vue';

// 导入动态表单组件

// 导入倒计时组件

// 导入卡信息表单组件

// 导出所有业务组件
export {
  // 卡信息表单组件
  CardInformationForm,
  CountrySelect,
  // 倒计时组件
  OnCountdownTimer,
  // 错误面板组件
  OnErrorMsgPanel,
  // 支付选项选择器
  OnPaymentOptionSelector,
  // 动态表单组件
  DynamicForm,
  FormField,
};

export default {
  // 卡信息表单组件
  CardInformationForm,
  CountrySelect,
  // 倒计时组件
  OnCountdownTimer,
  // 错误面板组件
  OnErrorMsgPanel,
  // 支付选项选择器
  OnPaymentOptionSelector,
  // 动态表单组件
  DynamicForm,
};
